define('app/views/register_form_social_view',['app/setup'],function(takhfifan) {
  takhfifan.registerFormSocialView = takhfifan.BaseView.extend({
    events: {
      'click .social-box': 'socialLoginSubmit'
    },
    initialize: function() {
      var _this = this;
      takhfifan.eventHub.on('socialconnect', function(socialconnect) {
        _this.activateSocialButtons(socialconnect);
      }, this);
    },
    activateSocialButtons: function(data) {
      this.$('a.tkh-google-login').prop('href', data.google);
      this.$('a.tkh-facebook-login').prop('href', data.facebook);
      this.$('a.tkh-twitter-login').prop('href', data.twitter);
      this.$('a.tkh-yahoo-login').prop('href', data.yahoo);
    },
    socialLoginSubmit: function (e) {
      e.preventDefault();
      this.setResetSessionFlag();
      window.location.href = $(e.currentTarget).attr('href');
    }
  });
});

